import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { BranchService, Branch } from '../../../services/data/branch.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  animations: [
    trigger('branchAnimation', [
      state('void', style({
        opacity: 0,
        height: '0px',
        overflow: 'hidden',
        display: 'none'
      })),
      state('*', style({
        opacity: 1,
        height: '*',
        overflow: 'visible',
        display: 'flex'
      })),
      transition('void => *', [
        style({ opacity: 0, height: '0px' }),
        animate('0.5s ease-out')
      ]),
      transition('* => void', [
        animate('0.5s ease-in', style({
          opacity: 0,
          height: '0px'
        }))
      ])
    ])
  ]
})
export class ContactComponent implements OnInit {
  showBranches = false;
  language: string;
  branches: Branch[] = [];

  constructor(private translate: TranslateService,
              public analyticsService: AnalyticsService,
              private branchService: BranchService) {}

  ngOnInit(): void {
    this.language = localStorage.getItem("language");
    const language = this.language === "en" ? "en" : "ar";
    this.branches = this.branchService.getBranches(language);
  }

  toggleBranches() {
    this.showBranches = !this.showBranches;
  }

  openMap(mapLink: string) {
    window.open(mapLink, '_blank');
  }
}
